// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isMessagingServicesResult = arrayOf(
  objectOf({
    id: string,
    name: string,
    // I'm not sure how phone_numbers looks, or if all channels have it
    phone_numbers: maybe(arrayOf(objectOf({}))),
    subscription_group: objectOf({
      id: string,
      name: string,
      external_id: string,
      link_shortening_domain: maybe(string),
    }),
  })
);
